export type CountdownUnit = 'seconds' | 'minutes' | 'hours-and-minutes';

export function getCountdownUnit(msRemaining: number): CountdownUnit {
  const totalSeconds = Math.max(0, Math.floor(msRemaining / 1000));

  if (totalSeconds < 60) {
    return 'seconds';
  }

  const totalMinutes = Math.floor(totalSeconds / 60);

  if (totalMinutes < 60) {
    return 'minutes';
  }

  return 'hours-and-minutes';
}
